import { TourTravel } from '../entities/project-tour-ontour-travel.entity';

export function getTourTravelsLinkedToTourEvent(
  tourTravels: TourTravel[],
  tourEventId: number,
) {
  return tourTravels.filter(
    (x) => x.toEventId === tourEventId || x.fromEventId === tourEventId,
  );
}
